/*
 * This model holds the data for curriculum api access page of the calcualtor
 *
 */
import httpClient from 'client/js/models/http-client'

class Calendar {
   static async getTeachingPeriods(year) {
      try {
         const payload = {
            year,
         };
         let response = await httpClient.post(BaseURL + "/api/calendar/teaching-periods/", payload)
         return response.data && response.data.calendars ? response.data.calendars : []
      } catch (err) {
         let response = err.response
         if (response && response.data.response)
            throw new Error(response.data.response)
         throw (err)
      };
   }
}

module.exports = Calendar
